import React from 'react';
import PropTypes from 'prop-types';
import { DebounceInput } from 'react-debounce-input';

const EmailInput = ({
    className, placeholder, onChange, label, error, divClassName, value, req
}) => (
        <div className={divClassName}>
            <DebounceInput
                placeholder={placeholder}
                className={className}
                debounceTimeout={100}
                onChange={onChange}
                forceNotifyByEnter={false}
                value={value}
            />
            <label className="active" htmlFor={label}>{label} {req ? "*" : ""}</label>

            {/* <input id="Email" type="text" placeholder="placeholder" className="validate" /> */}

            {error && <span className="help-block invalid ">{error}</span>}
        </div>
    );


EmailInput.propTypes = {
    onChange: PropTypes.func,
    className: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    req: PropTypes.any,
};

EmailInput.defaultProps = {
    placeholder: 'Email',
    className: 'form-control',
    req: false,

};

export default EmailInput;